import React from 'react';
import { connect } from 'react-redux';

import classes from './MealsPaxSelect.scss';
import Checkbox from '../../../UI/CommonCheckBox/CommonCheckBox';
import maleTravellerImage from './img/adult-male.svg';

import * as farePriceActions from '../../../../store/actions/index';

const mealsPaxSelect = (props) => {
    return (
        <ul>
            {   props.passengers.map(passenger => {
                    if(passenger.isSelected && passenger.travellerDetails.passengerClass !== 'INF') {
                        return <li className={`${classes.ListItem} u-transitionAll300Ease`} key={passenger.paxID} onClick={
                            passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc === "" ? 
                            () => {
                                props.onSelectMeal(passenger.paxID, props.flow, passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc === props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc)
                                props.onAddAddon({addonLabel: "Meals", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})
                             } : (
                                () => {
                                    props.onRemoveAddon("Meals", parseInt(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                    props.onDeselctMeal(passenger.paxID, props.flow);
                                }
                            )}>
                        <div className={`u-flex align-items-center`}>
                            <img src={maleTravellerImage} alt='Meal' className={`u-size46x46 mr-2`}/>
                            <div className={`u-flex justify-content-center f-column`}>
                                <p className={`u-fontSize13 u-textColorDark`}>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName}</p>
                                <p>
                                    <span className={`u-fontSize13 u-textColorLight`}>{passenger.ssrDetails.ssrMealDetails.length !== 0 ? props.flow === 'O' ? passenger.ssrDetails.ssrMealDetails[0][props.mealsViewOIndex].desc : passenger.ssrDetails.ssrMealDetails[1][props.mealsViewRIndex].desc : null}</span>
                                    <span style={{display: (passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== "" && (passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc))  ? 'inline-block' : 'none'}}>
                                        {
                                            passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc ? 
                                            <React.Fragment>
                                                <span className="u-textColorDark">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                <span onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    props.onRemoveAddon("Meals", parseInt(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                                    props.onSelectMeal(passenger.paxID, props.flow);
                                                    props.onAddAddon({addonLabel: "Meals", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})}} className={`u-cursorPointer u-textColorPrimary u-fontSize13`}>Update</span>
                                            </React.Fragment> : null
                                        }
                                    </span>
                                </p>
                            </div>
                        </div>
                        <Checkbox type="ssr" readOnly checked={(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== "") ? true : false} />                
                    </li>
                    } else {
                        return null;
                    }
                })}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        mealsViewO: state.farePrice.mealsViewOneWay,
        mealsViewR: state.farePrice.mealsViewReturn,
        mealsViewOIndex: state.farePrice.mealsViewOneWayVal,
        mealsViewRIndex: state.farePrice.mealsViewReturnVal,
        selectedMeals: state.farePrice.selectedMeals
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectMeal: (id, flow, isUpdate) => dispatch(farePriceActions.selectMeal(id, flow, isUpdate)),
        onDeselctMeal: (id, flow) => dispatch(farePriceActions.deselectMeal(id, flow)),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(mealsPaxSelect);


// WEBPACK FOOTER //
// ./src/components/Addons/Meals/MealsPaxSelect/MealsPaxSelect.js